import { __decorate } from "tslib";
import { Addon, ApiConfig } from '../../limitPrivateAPI';
import { PrivateAPINamespace } from '../PrivateAPINamespace';
let AccessibilityNamespace = class AccessibilityNamespace extends PrivateAPINamespace {
    async getSkipToContent() {
        return this.ps.ds.accessibility.skipToContent.get();
    }
    async setSkipToContent(appDefinitionId, value) {
        this.ps.ds.runInContext(appDefinitionId, () => this.ps.ds.accessibility.skipToContent.set(value));
        await this.ps.ds.waitForChangesAppliedAsync();
    }
    async getVisualFocus() {
        return this.ps.ds.accessibility.visualFocus.get();
    }
    async setVisualFocus(appDefinitionId, value) {
        this.ps.ds.runInContext(appDefinitionId, () => this.ps.ds.accessibility.visualFocus.set(value));
        await this.ps.ds.waitForChangesAppliedAsync();
    }
    async getAutoDomReorder() {
        return this.ps.ds.accessibility.autoDomReorder.get();
    }
    async setAutoDomReorder(appDefinitionId, value) {
        this.ps.ds.runInContext(appDefinitionId, () => this.ps.ds.accessibility.autoDomReorder.set(value));
        await this.ps.ds.waitForChangesAppliedAsync();
    }
};
AccessibilityNamespace.namespace = 'accessibility';
AccessibilityNamespace = __decorate([
    ApiConfig(Addon)
], AccessibilityNamespace);
export { AccessibilityNamespace };
//# sourceMappingURL=AccessibilityNamespace.js.map